export default {
  gift_card_removed: 'Cartão oferta removido',
  invalid_gift_card: 'Cartão oferta inválido',
  gift_card_applied: 'Cartão oferta aplicado',
};
